export const purchaseOrderKeys = {
  all: ["purchase-orders"] as const,
  lists: () => [...purchaseOrderKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...purchaseOrderKeys.lists(), filters] as const,
  totals: (filters: Record<string, unknown>) =>
    [...purchaseOrderKeys.all, "totals", filters] as const,
  details: () => [...purchaseOrderKeys.all, "detail"] as const,
  detail: (id: string) => [...purchaseOrderKeys.details(), id] as const,
};

export const poInvoiceLinkKeys = {
  all: ["po-invoice-links"] as const,
  lists: () => [...poInvoiceLinkKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...poInvoiceLinkKeys.lists(), filters] as const,
  details: () => [...poInvoiceLinkKeys.all, "detail"] as const,
  detail: (id: string) => [...poInvoiceLinkKeys.details(), id] as const,
};

export { poKanbanKeys } from "../board/hooks/kanban/query-keys";
